/**
 * @generated SignedSource<<ee0fb796a9eef69357aa61337f8eece8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OrganizationId_meQuery$variables = {};
export type OrganizationId_meQuery$data = {
  readonly me: {
    readonly id: string;
    readonly lastLmsPrefix: string | null;
  };
};
export type OrganizationId_meQuery = {
  response: OrganizationId_meQuery$data;
  variables: OrganizationId_meQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastLmsPrefix",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationId_meQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrganizationId_meQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f5db63b6b5d72487009180e8f11471a8",
    "id": null,
    "metadata": {},
    "name": "OrganizationId_meQuery",
    "operationKind": "query",
    "text": "query OrganizationId_meQuery {\n  me {\n    id\n    lastLmsPrefix\n  }\n}\n"
  }
};
})();

(node as any).hash = "2689823b60a55963802993fdc9340f66";

export default node;
